export const questionData = {
  hy: ["Ինչու՞ ընտրել WebsitePro.am-ը",[
  {
    title: "Բարձրորակ և արագ սպասարկում",
    text: "Մեր աշխատակիցները արձագանքում են ծառայությունների վերաբերյալ հարցերին և կազմակերպում են պատվերները՝ հնարավորինս կարճ ժամկետներում",
  },
  {
    title: "Մատուցված ծառայությունների որակ",
    text: "WebsitePro.am-ի պատրաստած վեբ կայքերն ու նախագծերն աչքի են ընկնում իրենց բարձր որակով, արդյունավետությամբ և գեղեցիկ ու ժամանակակից վիզուալով։",
  },
  {
    title: "Ժամանակին համընթաց շարժ",
    text: "Արագ զարգացող ծրագրավորման ոլորտում մեր կազմակերպությունը քայլում է ժամանակին համընթաց և ստեղծում է արդիական և մրցունակ նախագծեր",
  },
  {
    title: "Մատչելի արժեքներ",
    text: "Անկախ ծառայությունների առանձնահատուկ որակից, մեզ մոտ արժեքները բավականին մատչելի են և հասանելի բոլորին",
  },
  {
    title: "Հաճախորդի կարիքների պատշաճ բավարարում",
    text: "Մենք ամենուրեք հաշվի ենք առնում ձեր հատուկ պահանջներն ու առաջարկում անհատականացված լուծումներ՝ ձեր բիզնեսը կամ նախագիծը հաջողության հասնելու համար։",
  },
]],
  en: ["Why choose WebsitePro.am",[
  {
    title: "High-quality and fast service",
    text: "Our employees respond to questions about services and organize orders in the shortest possible time",
  },
  {
    title: "Quality of services provided",
    text: "Websites and projects prepared by WebsitePro.am stand out for their high quality, efficiency and beautiful and modern visuals",
  },
  {
    title: "Moving with the times",
    text: "In the rapidly developing programming industry, our organization keeps up with the times and creates modern and competitive projects",
  },
  {
    title: "Affordable prices",
    text: "Regardless of the exceptional quality of services, our prices are quite affordable and accessible to everyone",
  },
  {
    title: "Proper satisfaction of customer needs",
    text: "We take into account your specific requirements everywhere and offer personalized solutions to make your business or project a success",
  },
]],
  ru:["Почему стоит выбрать WebsitePro.am?",[
  {
    title: "Качественное и быстрое обслуживание",
    text: "Наши сотрудники отвечают на вопросы об услугах и организуют заказы в кратчайшие сроки.",
  },
  {
    title: "Качество предоставляемых услуг",
    text: "Сайты и проекты, подготовленные WebsitePro.am, отличаются высоким качеством, эффективностью, красивым и современным визуальным оформлением.",
  },
  {
    title: "Идти в ногу со временем",
    text: "В стремительно развивающейся индустрии программирования наша организация идет в ногу со временем и создает современные и конкурентоспособные проекты.",
  },
  {
    title: "Доступные цены",
    text: "Несмотря на высокое качество услуг, наши цены вполне демократичны и доступны каждому.",
  },
  {
    title: "Правильное удовлетворение потребностей клиентов",
    text: "Мы учитываем ваши особые требования и предлагаем индивидуальные решения, которые сделают ваш бизнес или проект успешным.",
  },
]]
}